export interface IGeneratedServerSideSourcesProvider {
    getAllNormalizationFileNames(): Promise<string[]>;
    getNormalizationFileContent(gfv: string): Promise<NodeJS.ReadableStream | null>;
    getAllAttachmentPathFileNames(): Promise<string[]>;
    getAttachmentPathsFileContent(gfv: string): Promise<NodeJS.ReadableStream>;
    getAttachmentPathsWithGfvsFileContent(gfv: string): Promise<NodeJS.ReadableStream>;
}
